<template>
  <div v-if="!isTag">
    {{ displayText }}
  </div>
  <Tag v-else :type="tagType">
    {{ displayText }}
  </Tag>
</template>

<script>
import Tag from '@/components/Tag/Tag.vue'

export default {
  name: 'StatusDisplay',
  components: {
    Tag,
  },
  props: {
    isTag: {
      type: Boolean,
      default: true,
    },
    displayText: {
      type: String,
      default: '',
    },
    tagType: {
      type: String,
      default: 'info',
    },
  },
}
</script>
